module.exports = __webpack_public_path__ + "static/img/compress.bac41118.gif";